import React from "react";

function Uploaded() {
  return (
    <div>
      <svg
        width="51"
        height="51"
        viewBox="0 0 51 51"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M25.5 1C28.7174 1 31.9033 1.63371 34.8757 2.86495C37.8482 4.09619 40.5491 5.90085 42.8241 8.17588C45.0992 10.4509 46.9038 13.1518 48.135 16.1243C49.3663 19.0967 50 22.2826 50 25.5C50 28.7174 49.3663 31.9033 48.135 34.8757C46.9038 37.8482 45.0992 40.5491 42.8241 42.8241C40.5491 45.0992 37.8482 46.9038 34.8757 48.135C31.9033 49.3663 28.7174 50 25.5 50C22.2826 50 19.0967 49.3663 16.1243 48.135C13.1518 46.9038 10.4509 45.0992 8.17588 42.8241C5.90085 40.5491 4.09619 37.8482 2.86495 34.8757C1.63371 31.9033 1 28.7174 1 25.5C1 22.2826 1.63371 19.0967 2.86495 16.1243C4.09619 13.1518 5.90085 10.4509 8.17589 8.17588C10.4509 5.90085 13.1518 4.09619 16.1243 2.86495C19.0967 1.63371 22.2826 1 25.5 1L25.5 1Z"
          stroke="#00B4FF"
          strokeWidth="2"
        />
        <path
          d="M33.5161 19L22.9032 29.9667L18.4839 25.4L17 26.9333L22.1613 32.2667L22.9032 33L23.6452 32.2667L35 20.5333L33.5161 19Z"
          fill="#00B4FF"
        />
      </svg>
    </div>
  );
}

export default Uploaded;
